import { FormProvider, useForm, type FieldErrors } from 'react-hook-form'

import { initialFormValues } from './form/initialFormValues'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { Button } from '@components/shared/Button'
import { MultiSelect } from '@components/shared/MultiSelect'

import type { WeeklyBreakdownFiltersFormProps } from './form/types'
import type { WeeklyBreakdownFiltersProps } from './types'

import * as S from './styles'

export const WeeklyBreakdownFilters = ({ availableServiceGroupings, availableSalesItemNames, onFilter, isLoading }: WeeklyBreakdownFiltersProps) => {
  const methods = useForm<WeeklyBreakdownFiltersFormProps>({
    defaultValues: initialFormValues
  })

  const onError = (errors: FieldErrors<WeeklyBreakdownFiltersFormProps>) => console.log({ errors })

  const onSubmit = (formData: WeeklyBreakdownFiltersFormProps) => onFilter(formData)

  return (
    <FormProvider {...methods}>
      <S.FiltersContainer>
        <S.InputsWrapper>
          <S.SelectWrapper>
            <MultiSelect
              name="serviceGroupingFilter"
              label="Agrupamento"
              options={availableServiceGroupings.map((item) => ({ label: item, value: item }))}
              disabled={isLoading}
            />
          </S.SelectWrapper>

          <S.SelectWrapper>
            <MultiSelect
              name="salesItemNameFilter"
              label="Descrição Serviço"
              options={availableSalesItemNames.map((item) => ({ label: item, value: item }))}
              disabled={isLoading}
            />
          </S.SelectWrapper>
        </S.InputsWrapper>

        <S.FilterButtons>
          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<FilterIcon />}
            onClick={() => methods.handleSubmit(onSubmit, onError)()}
            disabled={isLoading}
          >
            Filtrar
          </Button>

          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<CloseIcon />}
            onClick={() => {
              methods.reset()
              onFilter(initialFormValues)
            }}
            disabled={isLoading}
          >
            Limpar
          </Button>
        </S.FilterButtons>
      </S.FiltersContainer>
    </FormProvider>
  )
}
